
// STATES REDUCER

const defaultState = {
    data: [],
    error: false,
    loading: false,
};


export default (state = defaultState, action) => {

    switch (action.type) {

        case 'SET_STATES_DATA':
            return {...state, data: action.data}

        case 'SET_STATES_ERROR':
            return {...state, error: action.data}

        case 'SET_STATES_LOADING':
            return {...state, loading: action.data}
        default:
            return state
    }
}
